export { default } from './IdentityRequirementsDuringSignUp.container';
export { default as IdentityRequirementsDuringActivate } from './IdentityRequirementsDuringActivate.container';
